import React, { useState } from "react";
import { Accordion, Button, Card, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaRegTrashAlt } from "react-icons/fa";
import { SetPermission } from "../SetPermission/Permissions";
import toastr from "toastr";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { moduleTypeView } from "app/_constants/constant";
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from "react-icons/md";
import { deleteInformationLabel } from "./Constant";
import { confirmAlert } from "react-confirm-alert";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const DeleteRecordIcon = ({
  id,
  moduleType,
  setLoading = () => {},
  reloadData = () => {},
}) => {
  const [confirmation, setConfirmation] = useState(false);
  const [recordData, setRecordData] = useState("");

  const handleDelete = async (id, moduleType, deleteFlag = false) => {
    if (!id || !moduleType) return;
    if (deleteFlag) setLoading(true);
    const queryFilter = { id, moduleType, ...(deleteFlag ? { deleteFlag } : {}) };

    const response = await CommmonService.deleteRecord(queryFilter);
    if (!response?.status) {
      toastr.error(response?.message);
      setLoading(false);
      return;
    }
    if (!deleteFlag) {
      setConfirmation(true);
      setRecordData(response?.deleteData);
    } else {
      setConfirmation(false);
      setRecordData("");
      reloadData();
      toastr.success(response?.message);
    }
  };

  const onHideConfirmation = () => {
    setConfirmation(false);
  };

  const confirmationAlert = (id, moduleType) => {
    confirmAlert({
      title: "Deleting record",
      message: "Are you sure you want to delete the record?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            handleDelete(id, moduleType, true);
          },
        },
        {
          label: "No",
          onClick: () => {
            setConfirmation(false);
          },
        },
      ],
    });
  };

  return (
    <>
      <SetPermission
        permission={["superAdmin"]}
        data={
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top"> Delete</Tooltip>}
          >
            <a
              href
              className="icons pointer text-danger"
              onClick={() => handleDelete(id, moduleType)}
            >
              <FaRegTrashAlt />
            </a>
          </OverlayTrigger>
        }
      />
      <DeleteRecordPopup
        confirmation={confirmation}
        onHideConfirmation={onHideConfirmation}
        title={moduleTypeView[moduleType]}
        recordData={recordData}
        moduleType={moduleType}
        id={id}
        confirmationAlert={confirmationAlert}
      />
    </>
  );
};

export default DeleteRecordIcon;

export const DeleteRecordPopup = ({
  confirmation,
  onHideConfirmation,
  title,
  recordData,
  moduleType,
  id,
  confirmationAlert,
}) => {
  // Track open indexes, all open initially
  const [openIndexes, setOpenIndexes] = useState(
    (deleteInformationLabel[moduleType] || []).map((_, idx) => idx)
  );

  const toggleSection = (index) => {
    setOpenIndexes(
      (prev) =>
        prev.includes(index)
          ? prev.filter((i) => i !== index) // close
          : [...prev, index] // open
    );
  };

  const renderTableCell = (col, data, key) => {
    const cellContent = col?.link ? (
      <Link className="icons text-cyanBlue" target="_blank" to={`${col.link}${data?.id}`}>
        {data[col.accessor]}
      </Link>
    ) : (
      data[col.accessor]
    );

    return col?.link ? (
      <OverlayTrigger
        key={key}
        placement="top"
        overlay={<Tooltip id={`tooltip-top-${key}`}>View</Tooltip>}
      >
        <td>{cellContent}</td>
      </OverlayTrigger>
    ) : (
      <td key={key}>{cellContent}</td>
    );
  };

  return (
    <>
      <Modal
        size="lg"
        show={confirmation}
        onHide={onHideConfirmation}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>
            <h4> {`Delete ${title} Record`}</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="incidentDetailAcc">
            {(deleteInformationLabel[moduleType] || []).map((section, index) => {
              const sectionData = recordData?.[section.key];

              if (
                !sectionData ||
                (Array.isArray(sectionData) && sectionData.length === 0) ||
                (!Array.isArray(sectionData) && Object.keys(sectionData).length === 0)
              ) {
                return null;
              }

              const isOpen = openIndexes.includes(index);

              return (
                <React.Fragment key={section.key}>
                  <Card.Header
                    onClick={() => toggleSection(index)}
                    className="pl-0"
                    style={{ cursor: "pointer" }}
                  >
                    {section.label}
                    <span style={{ float: "right" }}>
                      {isOpen ? <MdKeyboardArrowDown /> : <MdKeyboardArrowRight />}
                    </span>
                  </Card.Header>

                  {isOpen && (
                    <Card.Body>
                      <div className="table-responsive scrlHght">
                        <table className="table table-bordered">
                          <thead className="tableHead-bg">
                            <tr>
                              {section.columns.map((col, i) => (
                                <th key={i}>{col.header}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {Array.isArray(sectionData) ? (
                              sectionData.map((item, i) => (
                                <tr key={i}>
                                  {section.columns.map((col, j) =>
                                    renderTableCell(col, item, j)
                                  )}
                                </tr>
                              ))
                            ) : (
                              <tr>
                                {section.columns.map((col, i) =>
                                  renderTableCell(col, sectionData, i)
                                )}
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </Card.Body>
                  )}
                </React.Fragment>
              );
            })}
          </div>

          {/* <div className="bttm-text">
            <span>{`Do you want to continue deleting this record?`}</span>
          </div> */}
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <div>
            <Button
              onClick={() => {
                confirmationAlert(id, moduleType);
              }}
              variant="primary"
            >
              Yes
            </Button>
            <Button
              className="ml-2"
              variant="secondary"
              onClick={() => onHideConfirmation()}
            >
              {"No"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
